import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Reset scroll to the top of the page on every React Router navigation.
 *
 * Without this, clicking a tab tile from mid-page on the home band
 * loads the new page still scrolled to the tile's Y coordinate — the
 * user lands in the middle of the new content and has to scroll up
 * to see its title. The browser doesn't reset scroll on SPA route
 * changes because the document itself never reloads.
 *
 * Renders nothing — pure side-effect component that lives inside
 * <BrowserRouter> once, at the top of the tree.
 */
export function ScrollToTop(): null {
  const { pathname, search } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname, search]);

  return null;
}
